import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorRuleComponent } from './author-rule.component';
import { TnxSharedModule } from 'tnx-shared';
import { AuthorRuleFormComponent } from './author-rule-form/author-rule-form.component';
import { AuthorRuleRoutes } from './author-rule.routing';


export function declaration() {
    return [AuthorRuleComponent, AuthorRuleFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class AuthorRuleModule {
}

@NgModule({
    imports: [AuthorRuleModule, AuthorRuleRoutes],
    exports: [AuthorRuleModule]
})
export class AuthorRuleWithRouteModule {
}
